import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Loader2, HardHat, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

const API = window.location.origin;

export default function MobileLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/mobile/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Erreur');
      localStorage.setItem('emp_token', data.session_token);
      localStorage.setItem('emp_data', JSON.stringify(data.employee));
      navigate('/mobile/home');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-500 to-orange-600 flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
            <HardHat className="h-9 w-9 text-orange-500" />
          </div>
          <h1 className="text-2xl font-black text-white">SpaceLeadX</h1>
          <p className="text-orange-100 text-sm mt-1">Application terrain</p>
        </div>
        <form onSubmit={handleLogin} className="bg-white rounded-2xl p-6 shadow-xl space-y-4">
          <div className="space-y-1.5">
            <label className="text-sm font-medium text-gray-700">Courriel</label>
            <Input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="employe@exemple.com" required autoComplete="email"
              className="h-12 text-base bg-white text-gray-900 caret-gray-900 placeholder:text-gray-400" data-testid="mobile-email"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-medium text-gray-700">Mot de passe</label>
            <div className="relative">
              <Input
                type={showPassword ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Mot de passe" required autoComplete="current-password"
                className="h-12 text-base pr-12 bg-white text-gray-900 caret-gray-900 placeholder:text-gray-400" data-testid="mobile-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                data-testid="mobile-toggle-password"
              >
                {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
              </button>
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full h-12 bg-orange-500 hover:bg-orange-600 text-base font-bold" data-testid="mobile-login-btn">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Se connecter'}
          </Button>
        </form>
      </div>
    </div>
  );
}
